/* Список query-параметров, обрабатываемых приложением */
export enum QueryParams {
  /** Код авторизации при редиректе после авторизации */
  redirectCode = 'code',
  isMobileApp = 'is_mobile_app',
}
